/**
 * "Buy credits" dialog — wraps CreditPackPicker so the pricing page and the
 * account billing page both open the same self-serve Stripe checkout flow.
 * (The global paywall UpgradeModal embeds CreditPackPicker directly.)
 */

import { Sparkles } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { CreditPackPicker } from './CreditPackPicker';

export function BuyCreditsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** No longer rendered: with no packs the picker shows the unavailable state and Contact us. */
  fallback?: React.ReactNode;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-2 bg-primary">
            <Sparkles className="w-6 h-6 text-white" />
          </div>
          <DialogTitle>Buy credits</DialogTitle>
          <DialogDescription>
            Pick a pack. Credits never expire and remove the watermark.
          </DialogDescription>
        </DialogHeader>
        <CreditPackPicker />
      </DialogContent>
    </Dialog>
  );
}
